
import { defineComponent, toRefs, computed } from 'vue';

export default defineComponent({
    name: 'product-smart-units',
    props: {
        // Smart WMS base unit (dimension) and selling units (product_units with dimension)
        baseUnit: { type: Object, default: null },
        productUnits: { type: Array, default: () => [] }
    },
    setup(props) {
        const { baseUnit, productUnits } = toRefs(props);
        // e.g. ["PCS", "BOX (= 2 PCS)"]
        const sellingUnits = computed(() =>
            ((productUnits.value || []) as Record<any, any>[]).map((unit) => {
                const code = unit.dimension?.measurement ?? '';
                const conversion = Number(unit.conversion_to_base);
                return unit.is_base || conversion === 1 ? code : `${code} (= ${conversion} ${baseUnit.value?.measurement ?? ''})`;
            })
        );

        return {
            sellingUnits
        };
    }
});
